var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabs-transfer" },
    [
      _c("div", { staticClass: "tab-transfer" }, [
        _vm._v(_vm._s(_vm.$t("language.popup.chooseAction")))
      ]),
      _vm._v(" "),
      _c("cloud-select", {
        ref: "cloudSelect",
        staticStyle: { margin: "0px !important" },
        attrs: {
          widthVal: 400,
          selectOption: _vm.selectOption,
          placeholder: _vm.placeholderValue
        },
        on: { changeOption: _vm.onChangeOption }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tab-check" },
        _vm._l(_vm.checkItems, function(checkItem, index) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !(
                    _vm.$parent.$parent.$parent.item &&
                    _vm.$parent.$parent.$parent.item.branchType === "share" &&
                    (index == 0 || index == 1)
                  ),
                  expression:
                    "!($parent.$parent.$parent.item&&$parent.$parent.$parent.item.branchType==='share'&&(index==0||index==1))"
                }
              ],
              key: index,
              staticClass: "check-item"
            },
            [
              _c("div", {
                staticClass: "icon-util tab-float",
                class: [
                  _vm.checkArr.includes(index)
                    ? "check-small"
                    : "nocheck-small-blue",
                  index == 3 ? "tab-float" : "",
                  _vm.checkItemsIsDisable(index) ? "check-none" : ""
                ],
                on: {
                  click: function($event) {
                    return _vm.checkedItem(index)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "font",
                {
                  on: {
                    click: function($event) {
                      return _vm.checkedItem(index)
                    }
                  }
                },
                [_vm._v(_vm._s(checkItem.name))]
              ),
              _vm._v(" "),
              index == 2 || index == 3 || index == 4
                ? _c(
                    "div",
                    {
                      staticClass:
                        "icon-util question-mark question-mark-position",
                      on: {
                        mouseover: function($event) {
                          _vm.promptShow = true
                        },
                        mouseout: function($event) {
                          _vm.promptShow = false
                        }
                      }
                    },
                    [
                      index == 2
                        ? _c(
                            "div",
                            {
                              class:
                                _vm.$i18n.locale == "france"
                                  ? "prompt-right"
                                  : "prompt"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.popup.optionsPrompt"))
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      index == 3
                        ? _c(
                            "div",
                            {
                              class:
                                _vm.$i18n.locale == "france"
                                  ? "prompt-right"
                                  : "prompt-team"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.teamTransfer.optionActivated"
                                  )
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      index == 4
                        ? _c(
                            "div",
                            {
                              class:
                                _vm.$i18n.locale == "france"
                                  ? "prompt-right"
                                  : "prompt-team"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.teamTransfer.newTransTip")
                                )
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8c581d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8c581d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_transfer_options/tab_transfer.vue
// module id = null
// module chunks = 